import module from 'contabilidad/polizas/module.js'
import template from './template.html'
import { groupBy, orderBy } from 'lodash'

const formatearEmpresas = (data) => data.map((item) => ({id: item.ID_Cliente, descripcion: item.Nombre}))
const formatearClientes = (data) => data.map((item) => ({id: item.ID_Cliente, descripcion: item.Nombre}))
const formatearCuentasBancarias = (data) => data.map((item) => ({
  id: item.ID_Empleado_Banco,
  descripcion: `${item.Banco} ${item.Cuenta} ${item.Moneda}`,
  id_empresa: item.ID_Cliente,
}))

export class ContabilidadPolizasProvisioningresospagosComponent {
  fechaInicio
  fechaFin
  idCliente
  cuentaBancaria
  idsClientes
  campo
  cuentasBancarias = []
  data = null
  promise = null
  filtro = ''
  resultados = []
  opciones = {
    fecha_inicio: new Date(),
    fecha_fin: new Date(),
    ID_Cliente: undefined,
    CuentaBancaria: undefined,
    clientesFiltrado: [],
    campo: 'cliente',
  }
  catalogo = {
    empresas: [],
    cuentasBancarias: [],
    clientes: [],
  }

  constructor ($filter, $location, $q, $dialog, $catalogos, ContabilidadPolizas, provisionIngresosPagos) {
    this.$location = $location
    this.$q = $q
    this.$dialog = $dialog
    this.$catalogos = $catalogos
    this.ContabilidadPolizas = ContabilidadPolizas
    this.provisionIngresosPagos = provisionIngresosPagos
    this.filterBy = $filter('filter')
  }

  $onChanges (changes) {
    if (changes.fechaInicio && this.fechaInicio) this.opciones.fecha_inicio = this.fechaInicio
    if (changes.fechaFin && this.fechaFin) this.opciones.fecha_fin = this.fechaFin
    if (changes.idCliente && this.idCliente) this.opciones.ID_Cliente = this.idCliente
    if (changes.cuentaBancaria && this.cuentaBancaria) this.opciones.CuentaBancaria = this.cuentaBancaria
    if (changes.idsClientes && this.idsClientes) this.opciones.clientesFiltrado = this.idsClientes
    if (changes.campo && this.campo) this.opciones.campo = this.campo
  }

  $onInit () {
    const promises = [
      this.ContabilidadPolizas.obtenerClientes()
        .then((data) => this.catalogo.empresas = orderBy(formatearEmpresas(data), ['descripcion'])),
      this.$catalogos.get('cuentasBancarias')
        .then((data) => this.cuentasBancarias = groupBy(orderBy(formatearCuentasBancarias(data), ['descripcion']), 'id_empresa')),
      this.$catalogos.get('clientes')
        .then((data) => this.catalogo.clientes = orderBy(formatearClientes(data), ['descripcion'])),
    ]

    if (this.fechaInicio && this.fechaFin && this.idCliente && this.cuentaBancaria && this.idsClientes && this.campo) {
      promises.push(
        this.provisionIngresosPagos.get(this.fechaInicio, this.fechaFin, this.idCliente, this.cuentaBancaria, this.idsClientes, this.campo)
          .then(({data}) => this.data = data),
      )
    }

    this.promise = this.$q.all(promises)
      .then(() => {
        if (this.opciones.ID_Cliente) {
          this.filtrarCuentasBancarias()
        }

        this.filtrar()
      })
  }

  exportar () {
    const cliente = (this.catalogo.empresas.find((item) => item.id === this.opciones.ID_Cliente) || {descripcion: ''}).descripcion

    this.$dialog.show('contabilidad.polizas.exportar', {
      data: this.data,
      fecha_inicio: this.opciones.fecha_inicio,
      config: {
        fecha_inicio: this.opciones.fecha_inicio,
        fecha_fin: this.opciones.fecha_fin,
        clientes: cliente,
        archivo: `Provision_Ingresos_Pagos ${this.opciones.fecha_inicio.toYMD()}`,
        tipo_poliza: 'provisionIngresosPagos',
      },
    })
  }

  filtrar () {
    this.resultados = this.filterBy(this.data, this.filtro)
  }

  filtrarCuentasBancarias () {
    this.catalogo.cuentasBancarias = this.opciones.ID_Cliente
      ? this.cuentasBancarias[this.opciones.ID_Cliente]
      : []
  }

  obtenerInformacion () {
    this.$location.search({
      fecha_inicio: this.opciones.fecha_inicio.toYMD(),
      fecha_fin: this.opciones.fecha_fin.toYMD(),
      ID_Cliente: this.opciones.ID_Cliente,
      CuentaBancaria: this.opciones.CuentaBancaria,
      ids_clientes: this.opciones.clientesFiltrado,
      campo: this.opciones.campo,
    })
  }
}

module.component('contabilidadPolizasProvisioningresospagos', {
  controller: ContabilidadPolizasProvisioningresospagosComponent,
  template,
  bindings: {
    fechaInicio: '<',
    fechaFin: '<',
    idCliente: '<',
    cuentaBancaria: '<',
    idsClientes: '<',
    campo: '<',
  },
})



// WEBPACK FOOTER //
// ./src/contabilidad/polizas/components/provisioningresospagos/component.js